module.exports = __webpack_public_path__ + "static/media/quechua_tent.2a826aa8.png";